<label class="form-zone-label">Attributs à renseigner *</label>
<fa-icon [icon]="faCircleInfo" class="info-icon" [hubToolTip]="attributesAssignmentTooltipContent" [tooltipPosition]="'bottom'"></fa-icon>

<div class="table-container">
    <table #resultsTable mat-table matSort class="table-columns-definition" [dataSource]="attributesDatasource">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef [ngClass]="{ 'no-action': disabled }">Attribut</th>
            <td mat-cell *matCellDef="let element" [ngClass]="{ 'no-action': disabled }">{{ element.attributeName }}</td>
        </ng-container>
        <ng-container matColumnDef="value">
            <th mat-header-cell *matHeaderCellDef [ngClass]="{ 'no-action': disabled }">Valeur</th>
            <td mat-cell *matCellDef="let element" [ngClass]="{ 'no-action': disabled }">{{ element.attributeValue }}</td>
        </ng-container>
        <ng-container matColumnDef="format">
            <th mat-header-cell *matHeaderCellDef [ngClass]="{ 'no-action': disabled }">Format</th>
            <td mat-cell *matCellDef="let element" [ngClass]="{ 'no-action': disabled }">{{ element.attributeFormat }}</td>
        </ng-container>

        @if (!disabled) {
            <ng-container matColumnDef="action" stickyEnd>
                <th mat-header-cell *matHeaderCellDef class="action-column">
                    <mat-icon id="addIcon" class="icon-add-filters" (click)="onAddAttribute()" matTooltip="Ajouter un attribut" matTooltipPosition="below">add</mat-icon>
                </th>
                <td mat-cell *matCellDef="let row" class="action-column">
                    <mat-icon (click)="onEditAttribute(row)" matTooltip="Éditer l'attribut" matTooltipPosition="below">edit</mat-icon>
                    <mat-icon (click)="onDeleteAttribute(row.attributeId)" matTooltip="Supprimer l'attribut" matTooltipPosition="below">delete</mat-icon>
                </td>
            </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="attributesTableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: attributesTableColumns"></tr>
    </table>
</div>
